import type { Category } from "@/constants/categories";

type UncategorizedProduct = {
  id: string;
  name: string;
  categorySlug: Category["slug"];
  brand: string;
  price: number;
  unit: string;
  image: string;
};

const IMG = {
  misc: "https://images.unsplash.com/photo-1604719312566-8912e9227c6a?crop=entropy&cs=srgb&fm=jpg&q=85",
};

const item = (
  id: string,
  name: string,
  brand: string,
  unit: string,
  price: number,
): UncategorizedProduct => ({
  id,
  name,
  categorySlug: "uncategorized",
  brand,
  unit,
  price,
  image: IMG.misc,
});

export const UNCATEGORIZED_PRODUCTS: UncategorizedProduct[] = [
  // Page 1 — Oils, cleaning, candy
  item("unc-baby-oil", "Baby Oil", "Johnson's", "200ml", 5.99),
  item("unc-olive-oil-evoo", "Extra Virgin Olive Oil", "Borges", "500ml", 12.99),
  item("unc-olive-oil-pure", "Pure Olive Oil", "Borges", "500ml", 9.99),
  item("unc-olive-oil-light", "Light Olive Oil", "Borges", "500ml", 9.49),
  item("unc-dishwash-liquid", "Dishwash Liquid", "Pril", "500ml", 3.99),
  item("unc-glass-cleaner", "Glass Cleaner", "Colin", "500ml", 4.49),
  item("unc-fabric-softener", "Fabric Softener", "Comfort", "860ml", 6.99),
  item("unc-haribo-goldbears", "Haribo Goldbears", "Haribo", "160g", 3.49),
  item("unc-haribo-happy-cola", "Haribo Happy Cola", "Haribo", "160g", 3.49),
  item("unc-haribo-starmix", "Haribo Starmix", "Haribo", "160g", 3.49),
  item("unc-haribo-tangfastics", "Haribo Tangfastics", "Haribo", "160g", 3.49),
  item("unc-haribo-supermix", "Haribo Supermix", "Haribo", "160g", 3.49),
  item("unc-haribo-strawbs", "Haribo Strawbs", "Haribo", "160g", 3.49),
  item("unc-haribo-giant-strawbs", "Haribo Giant Strawbs", "Haribo", "160g", 3.49),
  item("unc-haribo-sour-mix", "Haribo Sour Mix", "Haribo", "160g", 3.49),

  // Sweetzone candy
  item("unc-sweetzone-fizzy", "Sweetzone Fizzy Mix", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-fizzy-cola", "Sweetzone Fizzy Cola", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-pencils", "Sweetzone Pencils", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-bubblegum", "Sweetzone Bubblegum Bottles", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-bears", "Sweetzone Bears", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-worms", "Sweetzone Worms", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-party-mix", "Sweetzone Party Mix", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-mallows", "Sweetzone Mallows", "Sweetzone", "200g", 3.99),

  // Spreads
  item("unc-nutella-200", "Nutella", "Ferrero", "200g", 5.99),
  item("unc-nutella-750", "Nutella", "Ferrero", "750g", 11.99),
  item("unc-skippy-natural-creamy", "Skippy Natural Creamy Peanut Butter", "Skippy", "462g", 8.99),
  item("unc-skippy-reduced-fat-chunky", "Skippy Reduced Fat Super Chunky", "Skippy", "462g", 8.99),

  // Cleaning & household
  item("unc-bleach-thick", "Thick Bleach", "Domestos", "750ml", 4.99),
  item("unc-toilet-cleaner", "Toilet Cleaner", "Harpic", "500ml", 4.49),
  item("unc-floor-cleaner", "Floor Cleaner", "Dettol", "1L", 6.99),

  // Batteries
  item("unc-toshiba-aa-4pk", "Toshiba AA Batteries", "Toshiba", "4 pack", 4.99),
  item("unc-toshiba-aa-8pk", "Toshiba AA Batteries", "Toshiba", "8 pack", 8.49),
  item("unc-toshiba-aaa-4pk", "Toshiba AAA Batteries", "Toshiba", "4 pack", 4.99),
  item("unc-toshiba-aaa-8pk", "Toshiba AAA Batteries", "Toshiba", "8 pack", 8.49),

  // Baby
  item("unc-aptamil-1", "Aptamil Stage 1", "Aptamil", "900g", 29.99),
  item("unc-aptamil-2", "Aptamil Stage 2", "Aptamil", "900g", 29.99),
  item("unc-pampers-newborn", "Pampers Newborn", "Pampers", "84 pcs", 24.99),
  item("unc-pampers-size3", "Pampers Size 3", "Pampers", "68 pcs", 24.99),

  // Kinder / chocolate misc
  item("unc-kinder-surprise", "Kinder Surprise Egg", "Kinder", "20g", 2.99),
  item("unc-kinder-chocolate", "Kinder Chocolate Bars", "Kinder", "100g", 4.99),
  item("unc-maltesers", "Maltesers", "Mars", "140g", 5.49),

  // Kettle chips
  item("unc-kettle-salt-vinegar", "Kettle Sea Salt & Vinegar", "Kettle", "150g", 4.99),
  item("unc-kettle-mature-cheddar", "Kettle Mature Cheddar", "Kettle", "150g", 4.99),

  // Page 2 — Perfumes (Dorall Collection & more)
  item("unc-perf-dc-blue-lady", "DC Blue Lady", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-marine", "DC Marine", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-cloud", "DC Cloud", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-rose-pink", "DC Rose Pink", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-noir", "DC Noir", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-sport-spray", "DC Sport Body Spray", "Dorall Collection", "200ml", 12.99),
  item("unc-perf-dc-blue-spray", "DC Blue Body Spray", "Dorall Collection", "200ml", 12.99),
  item("unc-perf-dc-amber-spray", "DC Amber Body Spray", "Dorall Collection", "200ml", 12.99),
  item("unc-perf-dc-vintage", "DC Vintage", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-xchange", "DC Xchange", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-floral-pink", "DC Floral Pink", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-la-vie", "DC La Vie", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-red-passion", "DC Red Passion", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-gold-edition", "DC Gold Edition", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-crystal", "DC Crystal", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-purple-glam", "DC Purple Glam", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-blue-ocean", "DC Blue Ocean Men", "Dorall Collection", "100ml", 24.99),

  // Page 3 — Milka, Monster, drinks
  item("unc-milka-alpine-100", "Milka Alpine Milk", "Milka", "100g", 4.49),
  item("unc-milka-strawberry-100", "Milka Strawberry Cheesecake", "Milka", "100g", 4.79),
  item("unc-milka-oreo-100", "Milka Oreo", "Milka", "100g", 4.99),
  item("unc-milka-caramel-100", "Milka Caramel", "Milka", "100g", 4.79),
  item("unc-milka-hazelnut-100", "Milka Whole Hazelnut", "Milka", "100g", 4.79),
  item("unc-milka-white-100", "Milka White Chocolate", "Milka", "100g", 4.49),
  item("unc-milka-bubbly-100", "Milka Bubbly", "Milka", "100g", 4.79),
  item("unc-milka-noisette-100", "Milka Noisette", "Milka", "100g", 4.79),
  item("unc-monster-classic", "Monster Energy Classic", "Monster", "500ml", 3.99),
  item("unc-monster-ultra-white", "Monster Ultra White", "Monster", "500ml", 3.99),
  item("unc-monster-ultra-blue", "Monster Ultra Blue", "Monster", "500ml", 3.99),
  item("unc-monster-pipeline", "Monster Pipeline Punch", "Monster", "500ml", 3.99),
  item("unc-monster-mango-loco", "Monster Mango Loco", "Monster", "500ml", 3.99),
  item("unc-monster-ultra-paradise", "Monster Ultra Paradise", "Monster", "500ml", 3.99),
  item("unc-milka-biscuit-bar", "Milka Biscuit Chocolate Bar", "Milka", "150g", 5.49),

  // Sauces & dressings
  item("unc-cholula-hot-sauce", "Cholula Hot Sauce", "Cholula", "150ml", 6.49),
  item("unc-sweet-chilli-sauce", "Sweet Chilli Sauce", "Mae Ploy", "730ml", 5.99),
  item("unc-mango-sauce", "Mango Sauce", "Encona", "285ml", 4.49),
  item("unc-hot-pepper-sauce", "Hot Pepper Sauce", "Encona", "142ml", 3.99),
  item("unc-ranch-dressing", "Ranch Dressing", "Hidden Valley", "473ml", 6.99),
  item("unc-thousand-island", "Thousand Island Dressing", "Kraft", "473ml", 5.99),
  item("unc-coconut-cream", "Coconut Cream", "Kara", "400ml", 2.99),
  item("unc-apple-cider-vinegar", "Apple Cider Vinegar", "Bragg", "473ml", 7.99),

  // Page 4 — More perfumes
  item("unc-perf-dc-desire-pink", "DC Desire Pink", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-blue-ocean2", "DC Blue Sapphire", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-oriental-garden", "DC Oriental Garden", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-da-life", "DC Da Life", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-gold-femme", "DC Gold Femme", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-amber-gold", "DC Amber Gold", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-midnight-blue", "DC Midnight Blue", "Dorall Collection", "100ml", 24.99),
  item("unc-perf-dc-senorita", "DC Senorita", "Dorall Collection", "100ml", 19.99),
  item("unc-perf-dc-fleur-rose", "DC Fleur Rose", "Dorall Collection", "100ml", 19.99),

  // Page 5 — Herbs, spices, sauces, pantry
  item("unc-balsamic-vinegar", "Balsamic Vinegar", "Monini", "250ml", 6.99),
  item("unc-italian-dressing", "Italian Dressing", "Newman's", "250ml", 5.49),
  item("unc-soy-sauce-dark", "Dark Soy Sauce", "Kikkoman", "250ml", 4.99),
  item("unc-oyster-sauce", "Oyster Sauce", "Lee Kum Kee", "255g", 4.99),
  item("unc-worcestershire-sauce", "Worcestershire Sauce", "Lea & Perrins", "290ml", 5.99),
  item("unc-tabasco-original", "Tabasco Original", "Tabasco", "60ml", 4.49),
  item("unc-mixed-herbs", "Mixed Herbs", "Schwartz", "11g", 2.99),
  item("unc-oregano-dried", "Dried Oregano", "Schwartz", "11g", 2.99),
  item("unc-basil-dried", "Dried Basil", "Schwartz", "11g", 2.99),
  item("unc-paprika", "Paprika", "Schwartz", "34g", 3.49),
  item("unc-cumin-seeds", "Cumin Seeds", "Schwartz", "35g", 3.49),
  item("unc-turmeric", "Turmeric Ground", "Schwartz", "34g", 3.49),
  item("unc-cinnamon-sticks", "Cinnamon Sticks", "Schwartz", "13g", 3.49),
  item("unc-black-pepper", "Black Pepper Ground", "Schwartz", "34g", 3.49),
  item("unc-garlic-powder", "Garlic Powder", "Schwartz", "34g", 3.49),
  item("unc-nature-valley-crunchy", "Nature Valley Crunchy", "Nature Valley", "210g", 6.99),
  item("unc-nature-valley-protein", "Nature Valley Protein", "Nature Valley", "160g", 7.49),
  item("unc-tahini-paste", "Tahini Paste", "Al Arz", "454g", 8.99),
  item("unc-olive-oil-extra-virgin", "Extra Virgin Olive Oil", "Filippo Berio", "500ml", 12.99),
  item("unc-pampers-size4", "Pampers Size 4", "Pampers", "56 pcs", 24.99),
  item("unc-pampers-size5", "Pampers Size 5", "Pampers", "44 pcs", 24.99),

  // Page 6 — More candy & misc
  item("unc-sweetzone-cherry", "Sweetzone Cherry Drops", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-rainbow", "Sweetzone Rainbow Belts", "Sweetzone", "200g", 3.99),
  item("unc-sweetzone-millions", "Sweetzone Millions", "Sweetzone", "200g", 3.99),
  item("unc-flash-floor-cleaner", "Flash Floor Cleaner", "Flash", "1L", 5.99),
  item("unc-fairy-washing-up", "Fairy Washing Up Liquid", "Fairy", "900ml", 4.99),
  item("unc-aptamil-3", "Aptamil Stage 3", "Aptamil", "900g", 29.99),
  item("unc-kinder-bueno", "Kinder Bueno", "Kinder", "43g", 1.99),
  item("unc-reeses-cups", "Reese's Peanut Butter Cups", "Reese's", "42g", 2.49),
  item("unc-maltesers-box", "Maltesers Box", "Mars", "310g", 9.99),
  item("unc-nutella-go", "Nutella & Go", "Ferrero", "52g", 2.99),
  item("unc-olive-oil-spray", "Olive Oil Cooking Spray", "Frylight", "190ml", 4.99),

  // Page 7 — Juices, Pringles, chocolates
  item("unc-pringles-original", "Pringles Original", "Pringles", "165g", 4.99),
  item("unc-pringles-sour-cream", "Pringles Sour Cream & Onion", "Pringles", "165g", 4.99),
  item("unc-pringles-bbq", "Pringles BBQ", "Pringles", "165g", 4.99),
  item("unc-pringles-paprika", "Pringles Paprika", "Pringles", "165g", 4.99),
  item("unc-tropicana-orange", "Tropicana Orange Juice", "Tropicana", "1L", 5.99),
  item("unc-tropicana-apple", "Tropicana Apple Juice", "Tropicana", "1L", 5.99),
  item("unc-innocent-smoothie-mango", "Innocent Smoothie Mango", "Innocent", "750ml", 5.49),
  item("unc-innocent-smoothie-straw", "Innocent Smoothie Strawberry & Banana", "Innocent", "750ml", 5.49),
  item("unc-vg-chocolate-bar", "VG Chocolate Bar", "VG Mart", "100g", 3.49),
  item("unc-vg-cookies-pack", "VG Cookies Pack", "VG Mart", "200g", 4.99),
  item("unc-sparkling-wine-rose", "Sparkling Wine Rosé", "J.P. Chenet", "750ml", 14.99),
  item("unc-sparkling-wine-brut", "Sparkling Wine Brut", "J.P. Chenet", "750ml", 14.99),
  item("unc-sparkling-wine-peach", "Sparkling Wine Peach", "J.P. Chenet", "750ml", 14.99),
];
